import request from '#/utils/request';
import { parseVer4ListResponse } from '#/api/adapters/envelope';
import {
  joinMultiValueFilters,
  listQueryToApiParams,
} from '#/utils/listUrl/parseListSearchParams';

/**
 * 產品列表。
 * `GET /crm/product` — Ver4 list envelope。
 *
 * @param {object} listQuery
 */
export async function fetchProductList(listQuery) {
  const { data: raw } = await request.get('/crm/product', {
    params: listQueryToApiParams(joinMultiValueFilters(listQuery)),
  });
  return parseVer4ListResponse(raw);
}
